export const css = {
	root: '_0-HAj6KT',
	header: 'MTiKLFS1',
	content: 'OCJb-6dy',
	contentWrapper: '_7pC4ZEOV',
	copy: 'CQhS-b2P',
	title: 'thj9-hnX',
	subtitle: '_3W-zC3gl',
	description: 'FAuwILcj',
	actions: '_9UZQbpgi',
	backButton: 'fGAJAgFY',
	backButtonLabel: 'CSqZfihv',
	' _key': 'mc-widgets/final-test-view'
};

export default css;
